exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multi-select-checkbox .spark-checkbox {\n  padding-bottom: 1rem;\n  margin-bottom: 0; }\n\n.checkbox-no-margin .spark-checkbox {\n  padding-bottom: 0; }\n\n.spark-multi-select__label {\n  font-size: 1.66667rem !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/common/MultiSelect.scss
// module id = 1367
// module chunks = 0